export const getPipelineUrl = (pipelineId: number) => `/crm-pipeline/${pipelineId}`
